import React, { useState } from "react";
import { isMobile } from "../../Utils/media-query";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import useFetch from "../../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../Components/ErrorMessage";
import {
  DataGrid,
  Column,
  RequiredRule,
  Editing,
  SearchPanel,
  Button,
  Item,
  Toolbar,
} from "devextreme-react/data-grid";
import ActionNotifications from "../../Components/ActionNotifications";
import useGetSupplierList from "../../Hooks/useGET/useGetSupplierList";
import handleDelSupplierList from "../../Utils/handleDEL/handleDelSupplierList";
import handlePutSupplierList from "../../Utils/handlePUT/handlePutSupplierList";
import handlePostSupplierList from "../../Utils/handlePOST/handlePostSupplierList";

export default function DeliveryLocations() {
  const navigate = useNavigate(),
    fetch = useFetch(navigate),
    [notifyResponse, setResponse] = useState({});

  const fetchSuccessful = (response) => {
    setResponse(response);
    return (
      response?.success &&
      response?.data?.statusCode &&
      response?.success !== "Invalid Model"
    );
  };

  const { supplierList, mutate, error } = useGetSupplierList();

  const onRowRemoved = async (e) => {
    const { response, isDataGood } = await handleDelSupplierList(
      e.data.id,
      fetch,
    );
    fetchSuccessful(response);
    if (isDataGood) mutate();
  };
  const renderGrid = () => {
    const isButtonVisible = (e) => {
      if (e.row.data.type === 1) {
        return true;
      }
      return false;
    };
    const allowEditing = async (e) => {
      const gridData = e.changes[0];

      if (gridData?.type === "update") {
        const { response, isDataGood } = await handlePutSupplierList(
          gridData.data,
          fetch,
        );
        console.log("Put", gridData);
        fetchSuccessful(response);
        if (isDataGood) mutate();
      } else if (gridData?.type === "insert") {
        const { response, isDataGood } = await handlePostSupplierList(
          {
            name: gridData.data.name,
            contact: gridData.data.contact,
            email: gridData.data.email,
            adress: gridData.data.adress,
            // IsAs9100Approved: gridData.data.IsAs9100Approved,
          },
          fetch,
        );
        console.log("Post", gridData);
        fetchSuccessful(response);
        if (isDataGood) mutate();
      }
    };

    return (
      <DataGrid
        dataSource={supplierList}
        onSaved={allowEditing}
        onRowRemoved={onRowRemoved}
        fullScreen={isMobile}
        height="80vh"
        showBorders={true}
      >
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            render={() => (
              <div>
                <h1 className="white">Supplier List</h1>
              </div>
            )}
          />
          <Item name="addRowButton" />
          <Item name="searchPanel" />
        </Toolbar>
        <SearchPanel
          visible={true}
          searchVisibleColumnsOnly={true}
          placeholder="Search..."
        />
        <Editing allowAdding={true} allowUpdating={true} allowDeleting={true} />
        <Column type="buttons">
          <Button name="edit" />
          <Button name="delete" />
        </Column>

        <Column
          visible={false}
          dataField="id"
          alignment="left"
          allowEditing={false}
        />
        <Column dataField="name">
          <RequiredRule />
        </Column>
        <Column dataField="contact" visible={true} />
        <Column dataField="email" visible={true} />
        <Column dataField="adress" caption="Address" visible={true} />
      </DataGrid>
    );
  };

  return (
    <div className="px-lg-4 content">
      <ActionNotifications response={notifyResponse} />
      <div className="flexBoxRowSCC">
        <div className="px-2 page-content supplier-grid">
          <div className="contentBox my-3">
            {!error ? renderGrid() : <ErrorMessage />}
          </div>
        </div>
      </div>
    </div>
  );
}
